import React, { useEffect } from 'react'
import styles from './CustomCheckbox.module.css'

const CustomCheckbox = ({ onChange, type, displayType, value, labeltitle, name, className, pageType, selectedShipping, defaultShipping, feildRequired, heading, checkBox_errors, checked, onClick, ...props }: any) => {
	return (
		<label className={`${styles.label_wrapper} ${displayType === 'checkout' ? styles.margin : undefined} font-normal gray-color ${props?.address_type !== 'modal' ? undefined : 'w-[max-content]'} ${pageType === 'wishlist' ? styles.no_style : undefined}`} htmlFor={name}>
			{labeltitle} {feildRequired && <span className={`${styles.required} red-color`}>*</span>}
			<input {...props} checked={checked} className={`checkbox ${props?.address_type !== 'modal' ? 'w-full' : undefined} ${props?.address_type === 'modal' ? className : undefined}`} type={type} name={name} value={value} onChange={onChange} onClick={onClick} />
			<span className={`${styles.checkmark} ${checkBox_errors ? 'check-box-error' : undefined} ${type === 'radio' && 'full-radius'} ${type === 'radio' && styles.radio_check}`}> </span>
		</label>
	)
}

export default CustomCheckbox
